import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./helper-components.css";

// options.toastId: a repeat of the same toast while it still shows is ignored.
// Only toastId is read — some callers pass an Error as the second argument.
const errorToast = (message = "Something went wrong", options) => {
  toast.error(message, {
    toastId: options?.toastId,
    position: "top-center",
    autoClose: 4000,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "colored",
    className: "custom-toast",
  });
};

export default errorToast;
